import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const docsApiClient = axios.create({
  baseURL: `${BACKEND_URL}/api/docs`,
});

docsApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('docsToken') || localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

docsApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Docs API: Unauthorized');
    }
    return Promise.reject(error);
  }
);

export default docsApiClient;
